import React, { Suspense, lazy } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// Lazy load components
const QuoteButton = lazy(() => import('./QuoteButton'));
const LastUpdated = lazy(() => import('./LastUpdate'));
const SocialMedia = lazy(() => import('./SocialMedia'));

const CommonFooter = ({ lang, url, textName }) => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Row>
                <Col xs={4}>
                    <QuoteButton textName={textName} url={url} />
                </Col>
                <Col xs={4}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <SocialMedia shareUrl={url} />
                    </div>
                </Col>
                <Col xs={4} className="d-flex justify-content-end">
                    <LastUpdated lang={lang} />
                </Col>
            </Row>
        </Suspense>
    );
};

export default CommonFooter;
